import React from 'react';
import { Row, Col } from 'reactstrap';

const NoRowExistsRow = ({ emptyRowText }) => (
  <div>
    <Row>
      <Col md='12' className='empty-data-row'>
        {emptyRowText}
      </Col>
    </Row>
  </div>
);

export default NoRowExistsRow;
